import styled, { keyframes } from 'styled-components'
import Img from 'gatsby-image'
import { breakpoints } from '../../../styles/global';


export const loadAnimation = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`

export const Wrapper = styled.div`
  animation: ${loadAnimation} 0.3s forwards;
`

export const ProductImg = styled(Img)`
  @media (min-width: ${breakpoints.min.tablet}px) {
    max-height: 450px;   
  }
`

export const ImgWrapper = styled.div`
  position: relative;
`

export const ImgBanner = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.75);
  text-align: center;
`

export const BottomBannerText = styled.h3`
  color: black;
  margin: 0;
  padding: 0.5em 0;
  font-size: 1rem;
  text-decoration: underline;
`

export const HoverBanner = styled.div`
  position: absolute;
  background: radial-gradient(rgba(255, 255, 255, 0.9) 0, rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.5) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.5s ease;

  &:hover {
    opacity: 1;
  }
`

export const HoverTitle = styled.h2`
  font-size: 1rem;
  color: black;
  text-align: center;
`

export const HoverPrice = styled.h2`
  font-size: 1rem;
  color: black;
  text-align: center;
`

export const Title = styled.h2`
  ${'' /* font-weight: 300;
  font-size: 1.2rem;
  text-align: center; */}
`
